export const data = [
  {
    label: 'Email from name',
    value: '~email_from_name~'
  },
  {
    label: 'Quote id',
    value: '~quote_id~'
  },
  {
    label: 'Price',
    value: '~price~'
  },
  {
    label: 'Deposit',
    value: '~deposit~'
  },
  {
    label: 'Shipper not',
    value: '~shipper_note~'
  },
  {
    label: 'Customer firstname',
    value: '~cust_firstname~'
  },
  {
    label: 'Customer lastname',
    value: '~cust_lastname~'
  },
  {
    label: 'Shipper company',
    value: '~shipper_company~'
  },
  {
    label: 'Shipper email',
    value: '~shipper_email~'
  },
  {
    label: 'Shipper phone 1',
    value: '~shipper_phone1~'
  },
  {
    label: 'Shipper phone 2',
    value: '~shipper_phone2~'
  },
  {
    label: 'Shipper mobile',
    value: '~shipper_mobile~'
  },
  {
    label: 'Shipper fax',
    value: '~shipper_fax~'
  },
  {
    label: 'Shipper address 1',
    value: '~shipper_address1~'
  },
  {
    label: 'Shipper address 2',
    value: '~shipper_address2~'
  },
  {
    label: 'Shipper city',
    value: '~shipper_city~'
  },
  {
    label: 'Shipper state',
    value: '~shipper_state~'
  },
  {
    label: 'Shipper zipcode',
    value: '~shipper_zip~'
  },
  {
    label: 'Shipper note',
    value: '~shipper_note~'
  },
  {
    label: 'CC last 4',
    value: '~cc_last_four~'
  },
  {
    label: 'My name',
    value: '~my_name~'
  },
  {
    label: 'My phone',
    value: '~my_phone~'
  },
  {
    label: 'My phone 2',
    value: '~my_phone_2~'
  },
  {
    label: 'My company name',
    value: '~my_company_name~'
  },
  {
    label: 'My email',
    value: '~my_email~'
  },
  {
    label: 'My telephone',
    value: '~my_telephone~'
  },
  {
    label: 'My telephone extension',
    value: '~my_telephone_extension~'
  },
  {
    label: 'Origin',
    value: '~origin~'
  },
  {
    label: 'Origin Contact',
    value: '~origin_contact~'
  },
  {
    label: 'Origin phone',
    value: '~origin_phone~'
  },
  {
    label: 'Origin phone 2',
    value: '~origin_phone2~'
  },
  {
    label: 'Origin email',
    value: '~origin_email~'
  },
  {
    label: 'Origin address',
    value: '~origin_address~'
  },
  {
    label: 'Origin address 2',
    value: '~origin_address2~'
  },
  {
    label: 'Origin city',
    value: '~origin_city~'
  },
  {
    label: 'Origin state',
    value: '~origin_state~'
  },
  {
    label: 'Origin zipcode',
    value: '~origin_zipcode~'
  },
  {
    label: 'Destination',
    value: '~destination~'
  },
  {
    label: 'Destination Contact',
    value: '~destination_contact~'
  },
  {
    label: 'Destination phone',
    value: '~destination_phone~'
  },
  {
    label: 'Destination phone 2',
    value: '~destination_phone2~'
  },
  {
    label: 'Destination email',
    value: '~destination_email~'
  },
  {
    label: 'Destination address',
    value: '~destination_address~'
  },
  {
    label: 'Destination address 2',
    value: '~destination_address2~'
  },
  {
    label: 'Destination city',
    value: '~destination_city~'
  },
  {
    label: 'Destination state',
    value: '~destination_state~'
  },
  {
    label: 'Destination zipcode',
    value: '~destination_zipcode~'
  },
  {
    label: 'Vehicle list',
    value: '~vehicle_list~'
  },
  {
    label: 'Vehicle list running',
    value: '~vehicle_list_w_running~'
  },
  {
    label: 'Vehicle vin',
    value: '~vehicle_vin~'
  },
  {
    label: 'Vehicle year',
    value: '~vehicle_year~'
  },
  {
    label: 'Vehicle make',
    value: '~vehicle_make~'
  },
  {
    label: 'Vehicle model',
    value: '~vehicle_model~'
  },
  {
    label: 'Vehicle inop',
    value: '~vehicle_inop~'
  },
  {
    label: 'Carrier type',
    value: '~carrier_type~'
  },
  {
    label: 'Available date',
    value: '~available_date~'
  },
  {
    label: 'Delivery date',
    value: '~delivery_date~'
  },
  {
    label: 'Order description',
    value: '~order_description~'
  },
  {
    label: 'Order link',
    value: '~order_link~'
  },
  {
    label: 'Order link URL',
    value: '~order_source~'
  },
  {
    label: 'Billing link',
    value: '~billing_link~'
  },
  {
    label: 'Billing link URL',
    value: '~billing_source~'
  },
  {
    label: 'Dispatch message to carrier',
    value: '~dispatch_message_to_carrier~'
  },
  {
    label: 'Dispatch driver name',
    value: '~dispatch_driver_name~'
  },
  {
    label: 'Dispatch driver phone',
    value: '~dispatch_driver_phone~'
  },
  {
    label: 'Dispatch pickup date',
    value: '~dispatch_pickup_date~'
  },
  {
    label: 'Dispatch delivery date',
    value: '~dispatch_deliver_date~'
  },
  {
    label: 'Dispatch carrier pay',
    value: '~dispatch_carrier_pay~'
  },
  {
    label: 'Carrier name',
    value: '~carrier_name~'
  },
  {
    label: 'Carrier mc',
    value: '~carrier_mc~'
  },
  {
    label: 'Carrier dot',
    value: '~carrier_dot~'
  },
  {
    label: 'Dispatch driver phone',
    value: '~dispatch_driver_phone~'
  },
  {
    label: 'Carrier primary contact',
    value: '~carrier_primary_contact~'
  },
  {
    label: 'Carrier phone',
    value: '~carrier_phone~'
  },
  {
    label: 'Carrier email',
    value: '~carrier_email~'
  },
  {
    label: 'Carrier custom field 1',
    value: '~carrier_custom_field1~'
  },
  {
    label: 'Carrier custom field 2',
    value: '~carrier_custom_field2~'
  },
  {
    label: 'Carrier custom field 3',
    value: '~carrier_custom_field3~'
  },
  {
    label: 'Carrier custom field 4',
    value: '~carrier_custom_field4~'
  },
  {
    label: 'Carrier custom field 5',
    value: '~carrier_custom_field5~'
  },
  {
    label: 'Carrier custom text',
    value: '~carrier_custom_text~'
  },
  {
    label: 'Shipper custom text',
    value: '~shipper_custom_text~'
  },
  {
    label: 'Last payment amount',
    value: '~last_payment_amount~'
  },
  {
    label: 'Custom order number',
    value: '~custom_order_number~'
  },
  {
    label: 'Cash on delivery',
    value: '~cod~'
  },
  {
    label: 'Cash on pick up',
    value: '~cop~'
  },
  {
    label: 'Follow up shipper note',
    value: '~note_to_shipper~'
  },
  {
    label: 'Lot info',
    value: '~lot~'
  },
  {
    label: 'Terms and Conditions',
    value: '~terms_and_conditions~'
  },
  {
    label: 'Customer Review Page',
    value: '~customer_review_page~'
  }
].sort((a, b) => (a.label > b.label ? 1 : -1));
